import type { ClientApiV1PostsUserUserIdQueryString } from '../../../resources/@types/uccSchema';
import { logger } from '../../../resources/Logger';

export type CommunityPostType = 'question' | 'study' | 'chat' | 'PROJECT';

export const enum PostItemType {
  QUESTION = 'question',
  STUDY = 'study',
  CHAT = 'chat',
  PROJECT = 'PROJECT',
  ALL = 'ALL',
  ANSWER = 'ANSWER',
}

export const enum PostSort {
  RECOMMEND = 'RECOMMEND',
  RECENT = 'RECENT',
  OLDER = 'OLDER',
}

export function isQuestion(postType: string): boolean {
  return postType === PostItemType.QUESTION;
}

export function isAnswer(postType: string): boolean {
  return postType === PostItemType.ANSWER;
}

export function isStudy(postType: string): boolean {
  return postType === PostItemType.STUDY;
}

export function normalizePostType(
  postType: unknown,
): ClientApiV1PostsUserUserIdQueryString['type'] {
  if (
    postType === PostItemType.QUESTION.toUpperCase() ||
    postType === PostItemType.STUDY.toUpperCase() ||
    postType === PostItemType.CHAT.toUpperCase() ||
    postType === PostItemType.PROJECT ||
    postType === PostItemType.ANSWER
  ) {
    return postType as ClientApiV1PostsUserUserIdQueryString['type'];
  }

  return 'ALL';
}

export function normalizePostSort(sort: unknown): ClientApiV1PostsUserUserIdQueryString['sort'] {
  if (sort === PostSort.RECOMMEND || sort === PostSort.RECENT || sort === PostSort.OLDER) {
    return sort as ClientApiV1PostsUserUserIdQueryString['sort'];
  }

  return PostSort.RECENT;
}

export function convertPostTypeToPlural(postType: CommunityPostType): string {
  switch (postType) {
    case 'question':
      return 'questions';
    case 'study':
      return 'studies';
    case 'chat':
      return 'chats';
    case 'PROJECT':
      return 'projects';
    default:
      logger.info(`Invalid post type: ${postType}`);

      return 'questions';
  }
}

export function isResolvedStatus(status: string): boolean {
  return status === 'resolved' || status === 'recruited';
}
